/**
 * Sync plan(s) for the web Account page (Part C1). Config-driven so the real
 * tiers/prices can be swapped in when billing lands — at which point the
 * selected plan would actually be persisted. For now the card is a preview only:
 * the CTA triggers the free beta activation (see SyncPlansSection).
 *
 * Price is "per month"; the billing period (yearly/monthly) changes the
 * effective per-month price and the billing note (see `billedYearly` /
 * `billedMonthly` i18n keys). `nameKey` / `featuresKey` are i18n keys;
 * `featuresKey` resolves to a string[] via `t(key, { returnObjects: true })`.
 */
export interface SyncPlan {
  id: string
  nameKey: string
  /** Effective per-month price when billed monthly (EUR, placeholder). */
  priceMonthly: number
  /** Effective per-month price when billed yearly (EUR, placeholder). */
  priceYearly: number
  featuresKey: string
}

export const SYNC_PLANS: SyncPlan[] = [
  {
    id: 'sync',
    nameKey: 'account.plans.standard.name',
    priceMonthly: 5,
    priceYearly: 4,
    featuresKey: 'account.plans.standard.features',
  },
]
